import { useNavigate } from "react-router-dom";
import { useSwapContext } from "@src/contexts";
import { RoutePath } from "@src/interfaces";
import { Navigation, PageLayout } from "@src/components";

// TODO remove these logos
const SwapperFinanceLogo = () => (
  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center">
    <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z" />
    </svg>
  </div>
);

const LidoLogo = () => (
  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center">
    <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z" />
    </svg>
  </div>
);

interface Integration {
  name: string;
  description: string;
  integrationType?: string;
  logo: React.ComponentType;
  features: string[];
}

const integrations: Integration[] = [
  {
    name: "Swapper Finance",
    description: "Basic cryptocurrency trading with fiat onramp",
    integrationType: "swap",
    logo: SwapperFinanceLogo,
    features: [
      "Buy crypto with fiat",
      "Sell crypto to fiat",
      "Multi-chain support",
      "Low fees",
    ],
  },
  {
    name: "LIDO",
    description:
      "stETH - Ethereum's leading liquid staking token, with best-in-class security, deepest liquidity and competitive rewards",
    integrationType: "lido",
    logo: LidoLogo,
    features: [
      "Buy ETH and stake automatically",
      "Unstake stETH to ETH",
      "Earn staking rewards",
      "Liquid staking",
    ],
  },
];

export const IntegrationsView = () => {
  const navigate = useNavigate();
  const { setIntegrationTypeOverride } = useSwapContext();

  const handleIntegrationClick = (integration: Integration) => {
    // Set the integration type in the provider (undefined for default swap)
    setIntegrationTypeOverride(integration.integrationType);
    // Navigate to homepage
    navigate(RoutePath.Buy);
  };

  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: "Buy",
              path: RoutePath.Buy,
            },
            {
              content: "Sell",
              path: RoutePath.Sell,
            },
            {
              content: "Integrations",
              path: RoutePath.Integrations,
            },
          ]}
        />
      }
    >
      <div className="flex flex-col gap-6 h-full">
        {/* Integrations Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1">
          {integrations.map((integration) => {
            const LogoComponent = integration.logo;
            return (
              <div
                onClick={() => handleIntegrationClick(integration)}
                key={integration.name}
                className="bg-card_bg rounded-[20px] p-6 border border-gray-100 hover:border-gray-200 hover:bg-theme_color/10 transition-colors flex flex-col h-64 cursor-pointer"
              >
                <div className="flex items-start gap-4 mb-4">
                  <LogoComponent />
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-text_primary mb-2">
                      {integration.name}
                    </h3>
                  </div>
                </div>

                <p className="text-sm text-text_primary opacity-70 mb-6 flex-1">
                  {integration.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </PageLayout>
  );
};
